import fetch from "auth/FetchInterceptor";

const MachineService = {};

MachineService.index = function () {
  return fetch({
    url: "/machines",
    method: "get",
  });
};

MachineService.create = function (data) {
  return fetch({
    url: "/machines",
    method: "post",
    data,
  });
};

MachineService.update = function (id, data) {
  return fetch({
    url: `/machines/${id}`,
    method: "put",
    data,
  });
};

MachineService.delete = function (id) {
  return fetch({
    url: `/machines/${id}`,
    method: "delete",
  });
};

export default MachineService;